/**
 * @ngdoc service
 * @name app.photosFactory
 * @description Photos factory.
 * It works as local storage to carry images around the app.
 * its structure is as follows:
 * ``` js
 * {
 *  images: [],
 *  selIndex: 0,
 *  showImages: false,
 *  region: undefined
 * }
 * ```
 */

/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import angular from 'angular';

export default angular
  .module('photosService')
  .factory('photos', () => {
    return {
      images: [],
      selIndex: 0,
      showImages: false,
      region: undefined
    };
  });



/** WEBPACK FOOTER **
 ** ./client/app/services/shared/photos.js
 **/